export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NewUser.vue?vue&type=template&id=b78dfa3a&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/SystemManagement/users-management/new-user/NewUser.vue?vue&type=template&id=b78dfa3a&scoped=true&
// module id = null
// module chunks = 